import { render, staticRenderFns } from "./BaseDrawer.vue?vue&type=template&id=48c96b6e&scoped=true"
import script from "./BaseDrawer.vue?vue&type=script&lang=js"
export * from "./BaseDrawer.vue?vue&type=script&lang=js"
import style0 from "./BaseDrawer.vue?vue&type=style&index=0&id=48c96b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c96b6e",
  null
  
)

export default component.exports